import { FC } from 'react';
import { useSelectorWithConfig } from 'shared/hooks';
import { selectMortgagePromoSearchTypeFilter } from 'shared/selectors/advancedFilters/mortgagePromoSearchType';
import { MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { usePromoTypeChange } from '../hooks/usePromoTypeChange';

export const MultipleMortgageSearchTypeContainer: FC = () => {
  const { value, options } = useSelectorWithConfig(selectMortgagePromoSearchTypeFilter);
  const handleChange = usePromoTypeChange();

  return <MultiSelectionAdvancedFilter options={options} value={value} onFilterChange={handleChange} />;
};
